import { Modal, Button } from 'antd';
import React from 'react';
import image from '../../images/Landing_Illustration.png';

const RegisterModal = ({ visible, closeModal, t }) => (
  <Modal visible={visible} onCancel={closeModal} width={335} footer={false}>
    <img
      src={image}
      style={{
        width: '193px',
        height: 'auto',
        display: 'block',
        margin: '0 auto'
      }}
    />
    <p
      style={{
        color: '#4A90E2',
        textAlign: 'center',
        fontSize: '16px',
        marginTop: 20,
        fontFamily: 'Helvetica Neue',
        fontWeight: 500
      }}>
      {t(
        'Download the App, register and subscribe Service Tracker now to gain instant 30 days unlimited access for Free'
      )}
    </p>
    <Button
      type="primary"
      style={{ margin: '0 auto', display: 'block', width: 120 }}
      onClick={closeModal}>
      Done
    </Button>
  </Modal>
);

export default RegisterModal;



// WEBPACK FOOTER //
// ./src/components/LoginScreen/registerModal.js